/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-sub-hidden";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;

export const themeColorStorageKey = "__theme_selected_color";
export const isMultiColorActive = true;
export const defaultColor = "light.blueyale";
export const isDarkSwitchActive = true;
export const defaultDirection = "ltr";
export const themeRadiusStorageKey = "__theme_radius";
export const userStorageKey = process.env.REACT_APP_ECOMMERCE_ENDPOINT + "_user_storage";

export const isDemo = false;
export const colors = [
  "bluenavy",
  "blueyale",
  "blueolympic",
  // 'greenmoss',
  // 'greenlime',
  // 'purplemonster',
  // 'orangecarrot',
  // 'redruby',
  // 'yellowgranola',
  // 'greysteel',
];

export const FORMA_PAGTO_INDEFINIDA = 0;
export const FORMA_PAGTO_CARTAOCREDITO = 1;
export const FORMA_PAGTO_DEBITO_CONTA = 2;
export const FORMA_PAGTO_CONSIGNANTE = 3;
export const FORMA_PAGTO_BOLETO = 4;
export const FORMA_PAGTO_PIX = 5;

export const TIPO_FORMA_CONSIGNACAO_TOKEN = 1;
export const TIPO_FORMA_CONSIGNACAO_UPLOAD = 2;

export const PRODUTO_PREMIUM = 33;

export const TIPO_FORMA_PIX_PUSH_APLICATIVO = 1;
export const TIPO_FORMA_PIX_QRCODE_SEM_PAGAMENTO_ATO = 2;
export const TIPO_FORMA_PIX_QRCODE_COM_PAGAMENTO_PRIMEIRA_MENSALIDADE = 3;

export const UPLOAD_FILE_MAX_SIZE_ALLOWED_MB = 5; //(1024 * 1024 * 5 = 5.242.880 Bytes)
export const UPLOAD_FILE_EXTENSIONS_IMAGES_ALLOWED = ["image/jpeg", "image/gif", "image/bmp", "image/png", "application/pdf"];

export const TIPO_OCUPACAO_CIVIL = 3;

export const TIPO_ACEITE_CLIENTE = 1;
export const TIPO_ACEITE_PAGANTE = 2;

export const TIPO_PAGANTE_CONTRATANTE = "C";
export const TIPO_PAGANTE_TERCEIRO = "T";

export const FORMA_ENVIO_EMAIL = 1;
export const FORMA_ENVIO_SMS = 2;
export const FORMA_ENVIO_WHATSAPP = 3;

export const GERENCIAMENTO_USUARIOS = "ManagerUsers";
export const GERENCIAMENTO_FORMA_PGTO = "ManagerPayments";
export const GERENCIAMENTO_REINTEGRACAO_PROPOSTAS = "ManagerReintegracaoPropostas";

